import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  // 文件类型-图标 映射
  FILE_TYPE_AND_ICON_MAP: {
    'WORD': 'fa fa-file-word-o',
    'EXCEL': 'fa fa-file-excel-o',
    'PPT': 'fa fa-file-powerpoint-o',
    'PDF': 'fa fa-file-pdf-o',
    '图片': 'fa fa-file-picture-o',
    '视频': 'fa fa-file-video-o',
    '音频': 'fa fa-file-sound-o',
    '其它': 'fa fa-file-o'
  },
  // 当前登录用户
  user: {},
  // 登录后回调
  // 注：用于记录未登录时的AJAX请求，在登陆后重新执行，以免页面必要数据缺失或因强制刷新导致在编辑数据丢失
  callBackFuncWhenReLogin: [],
  /** ----↓屏幕大小相关，用于布局（由Frame.vue监听窗口变化重新计算）↓---- */
  // 窗口宽度
  windowInnerWidth: window.innerWidth,
  // 窗口高度
  windowInnerHeight: window.innerHeight,
  // 主体宽度
  mainWidth: window.innerWidth,
  // 是否手机
  isMobile: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
  // 是否pad
  isPad: /iPad/i.test(navigator.userAgent),
  // 是否窄屏
  isSmallWidth: window.innerWidth < 1200
  /** ----↑屏幕大小相关，用于布局（由Frame.vue监听窗口变化重新计算）↑---- */
}

const mutations = {
  // nothing
}

const actions = {
  // nothing
}

const getters = {
  // nothing
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js